function getEnv () {
  if (/(staging|localhost|127\.0\.0\.1|192\.168\.)/.test(window.location.href)) {
    return 'staging'
  } else {
    return 'production'
  }
}

const NODE_ENV = getEnv()

export default {
  env: NODE_ENV,
  api_base_url: NODE_ENV !== 'production' ? 'https://staging-neo.llsapp.com/api/v1' : 'https://apineo.llsapp.com/api/v1',
  share_api_base_url: NODE_ENV !== 'production' ? 'https://serah.llsstaging.com/api/v1' : 'https://serah.llsapp.com/api/v1',
  wx_share_register: NODE_ENV !== 'production' ? 'https://telis.llsstaging.com/' : 'https://apitelis.llsapp.com',
  app_url: NODE_ENV !== 'production' ? 'https://hybrid.llsstaging.com/lls-csr/' : 'https://hybrid.liulishuo.com/lls-csr/',
  universal_link: NODE_ENV !== 'production' ? 'https://hybrid.llsstaging.com/universal_link/navigate' : 'https://open-app.liulishuo.com/universal_link/navigate'
}



// WEBPACK FOOTER //
// ./src/config.js